import { render, staticRenderFns } from "./AppTableFooter.vue?vue&type=template&id=38f98a58&scoped=true&"
import script from "./AppTableFooter.vue?vue&type=script&lang=js&"
export * from "./AppTableFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppTableFooter.vue?vue&type=style&index=0&id=38f98a58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f98a58",
  null
  
)

export default component.exports